(function StartBooking($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		HE.onload('/Reservations/startcancelFromEmailBooking/', function onload()
		{
			$('#cancel-agree').click(function _enableSubmit() {

				if ($(this).prop('checked') === true) {
					$('.submit-booking').removeClass('disabled');
					$('.submit-booking').prop('disabled', null);
				} else {
					$('.submit-booking').addClass('disabled');
					$('.submit-booking').prop('disabled', true);
				}
			});
		});
	});
}(jQuery, window.HE || {}));